if (!customElements.get("collection-description-tabs")) {
  customElements.define(
    "collection-description-tabs",
    class CollectionDescriptionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tablist = this.querySelector('[role="tablist"]');
        this.indicator = this.querySelector(
          ".collection-description-tab-indicator",
        );
        if (!this.tabs.length) return;

        this.handleResize = () => this.updateIndicator();
        this.tabs.forEach((tab) =>
          tab.addEventListener("click", () => this.selectTab(tab)),
        );
        this.addEventListener("keydown", (event) => this.handleKeydown(event));
        window.addEventListener("resize", this.handleResize);
        this.updateIndicator();

        if (document.fonts) {
          document.fonts.ready.then(() => this.updateIndicator());
        }
      }

      disconnectedCallback() {
        if (this.handleResize) {
          window.removeEventListener("resize", this.handleResize);
        }
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          const panel = this.querySelector(
            `#${tab.getAttribute("aria-controls")}`,
          );

          tab.classList.toggle("active", selected);
          tab.setAttribute("aria-selected", selected);
          tab.tabIndex = selected ? 0 : -1;
          panel.hidden = !selected;
        });

        this.updateIndicator(selectedTab);
      }

      updateIndicator(selectedTab = this.querySelector('[role="tab"].active')) {
        if (!this.tablist || !this.indicator || !selectedTab) return;

        const text = selectedTab.querySelector(
          ".collection-description-tab-text",
        );
        const textRect = (text || selectedTab).getBoundingClientRect();
        const tablistRect = this.tablist.getBoundingClientRect();

        this.tablist.style.setProperty(
          "--tab-indicator-left",
          `${textRect.left - tablistRect.left}px`,
        );
        this.tablist.style.setProperty(
          "--tab-indicator-width",
          `${textRect.width}px`,
        );
      }

      handleKeydown(event) {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
          return;
        }

        const currentIndex = this.tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        event.preventDefault();
        let nextIndex;

        if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = this.tabs.length - 1;
        else if (event.key === "ArrowLeft")
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        else nextIndex = (currentIndex + 1) % this.tabs.length;

        this.selectTab(this.tabs[nextIndex]);
        this.tabs[nextIndex].focus();
      }
    },
  );
}
